export enum CrystalTripResultStatus {
  NoResult = 0,
  Partial = 1,
  Complete = 2,
}
